import { useContext, useState, MouseEvent } from 'react';
import styled from 'styled-components';
import {
  Avatar,
  Typography,
  Menu,
  MenuItem,
  Divider,
  Stack,
  IconButton,
  Tooltip,
} from '@mui/material';
import { Logout } from '@mui/icons-material';
import { UserAvatar } from '@vs-online-only-app/ui';
import { AuthenticationContext } from '@vs-online-only-app/state';

const OverflowWrapper = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 186px;
  display: block;
`;

export const AssociateDetails = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { user, logout } = useContext(AuthenticationContext);

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logOut = () => {
    logout();
    handleClose();
  };

  if (!user) {
    return null;
  }

  const fullName = `${user.firstName} ${user.lastName}`;
  const nameIsOverflowing = fullName.length > 20;
  const emailIsOverflowing = user.email.length > 20;

  return (
    <>
      <IconButton onClick={handleClick}>
        <UserAvatar
          imageSrc={user?.image}
          hasStatusIndicator
          isOnline={user?.available}
        />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        sx={{ marginTop: 1 }}
      >
        <Stack direction="row" gap={2} sx={{ padding: 2 }}>
          <Avatar src={user?.image} />
          <Stack>
            <Typography variant="body2" color="textSecondary">
              <Tooltip title={emailIsOverflowing ? user.email : null} arrow>
                <OverflowWrapper>{user.email}</OverflowWrapper>
              </Tooltip>
            </Typography>
            <Typography variant="body1">
              <Tooltip title={nameIsOverflowing ? fullName : null} arrow>
                <OverflowWrapper>{fullName}</OverflowWrapper>
              </Tooltip>
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <MenuItem onClick={logOut} sx={{ gap: 1 }}>
          <Logout fontSize="small" />
          Log out
        </MenuItem>
      </Menu>
    </>
  );
};
